<template>
  <div class="EditAddMarketplace">
    <el-form
      v-loading="loadingPage"
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      @submit.prevent
      v-on:submit.prevent
    >
      <HeaderPage>
        <el-button
          style="height: 44px; margin-left: 1rem"
          native-type="submit"
          @click.prevent="submitForm('ruleForm')"
          >Salvar</el-button
        >
        <el-dropdown v-if="ruleForm.id" trigger="click" @command="handleAction">
          <el-button
            type="text"
            icon="el-icon-more"
            class="el-dropdown-link"
          ></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-delete" divided command="DELETE"
              >Excluir</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </HeaderPage>
      <el-card
        shadow="never"
        :body-style="{ padding: '0px' }"
        style="background-color: transparent; border: none"
      >
        <el-tabs
          v-model="activeNameTabs"
          type="card"
          style="margin: 20px auto 0 auto; max-width: 1300px"
        >
          <el-tab-pane label="Geral" name="1">
            <el-row :gutter="20">
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item
                  prop="mcc_id"
                  label="Ramo de negócio"
                  :error="error.mcc_id"
                >
                  <SelectSearchMCC
                    :model="ruleForm.mcc_id"
                    :isEdit="isEdit"
                    @handleValue="
                      (x) => {
                        ruleForm.mcc_id = x;
                      }
                    "
                  />
                </el-form-item>
              </el-col> 
              <el-col :lg="5" :sm="5" :xs="24">
                <el-form-item
                  prop="type_person"
                  label="Tipo de pessoa"
                  :error="error.type_person"
                >
                  <el-select
                    v-model="ruleForm.type_person"
                    clearable
                    style="width: 100%"
                  >
                    <el-option label="Empresa" value="business" />
                    <el-option label="Individual" value="individual" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="11" :sm="11" :xs="24">
                <el-form-item prop="name" label="Nome" :error="error.name">
                  <el-input size="large" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="cpf" label="CPF" :error="error.cpf">
                  <el-input
                    masked="true"
                    size="large"
                    v-model="ruleForm.cpf"
                    v-mask="'###.###.###-##'"
                    required
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="rg" label="RG" :error="error.rg">
                  <el-input
                    masked="true"
                    size="large"
                    v-model="ruleForm.rg"
                    v-mask="'##.###.###-#'"
                    required
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="5" :sm="5" :xs="24">
                <el-form-item
                  prop="birthday"
                  label="Data de nascimento"
                  :error="error.birthday"
                >
                  <el-date-picker
                    style="width: 100%"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    v-model="ruleForm.birthday"
                    type="date"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="5" :sm="5" :xs="24">
                <el-form-item
                  prop="gender"
                  label="Género"
                  :error="error.gender"
                >
                  <el-select
                    v-model="ruleForm.gender"
                    clearable
                    style="width: 100%"
                  >
                    <el-option label="Masculino" value="male" />
                    <el-option label="Feminino" value="female" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="title_login" label="Titulo Login">
                  <el-input
                    size="large"
                    v-model="ruleForm.title_login"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item
                  prop="url_button_login"
                  label="Link (Tela de login)"
                >
                  <el-input
                    size="large"
                    type="url"
                    v-model="ruleForm.url_button_login"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24">
                <el-form-item prop="description_login" label="Descrição Login">
                  <el-input
                    size="large"
                    type="textarea"
                    :rows="2"
                    v-model="ruleForm.description_login"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="12" :sm="12" :xs="24">
                      <el-form-item
                        prop="name_store"
                        label="Nome da Loja"
                        :error="error.name_store"
                      >
                        <el-input
                          size="name_store"
                          v-model="ruleForm.name_store"
                        ></el-input>
                      </el-form-item>
                    </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="color_primary" label="Cor Primaria">
                  <el-color-picker
                    style="width: 100%"
                    v-model="ruleForm.color_primary"
                  ></el-color-picker>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="color_secondary" label="Cor Secundaria">
                  <el-color-picker
                    style="width: 100%"
                    v-model="ruleForm.color_secondary"
                  ></el-color-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider content-position="left">Contato</el-divider>
            <el-row :gutter="20">
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item
                  prop="type_contact"
                  label="Tipo do Contato"
                  :error="error.type_contact"
                >
                  <el-select
                    v-model="ruleForm.type_contact"
                    clearable
                    style="width: 100%"
                  >
                    <el-option label="Pessoal" value="personal" />
                    <el-option label="Empresa" value="business" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item
                  prop="phone_operator_id"
                  label="Operadora de telefone"
                  :error="error.phone_operator_id"
                >
                  <SelectSearchPhoneOperator
                    :model="ruleForm.phone_operator_id"
                    :isEdit="isEdit"
                    @handleValue="
                      (x) => {
                        ruleForm.phone_operator_id = x;
                      }
                    "
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="phone" label="Telefone">
                  <el-input
                    masked="true"
                    size="large"
                    v-model="ruleForm.phone"
                    v-mask="['(##) #####-####', '(##) ####-####']"
                    required
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="email" label="E-mail">
                  <el-input
                    type="email"
                    size="large"
                    v-model="ruleForm.email"
                    required
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="this.ruleForm.type_person === 'business'">
              <el-divider content-position="left">Empresa</el-divider>
              <el-row :gutter="20">
                <el-col :lg="24" :sm="24" :xs="24">
                  <el-row :gutter="20">
                    <el-col :lg="12" :sm="12" :xs="24">
                      <el-form-item
                        prop="business_cnpj"
                        label="CNPJ"
                        :error="error.business_cnpj"
                      >
                        <el-input
                          masked="true"
                          size="large"
                          v-model="ruleForm.business_cnpj"
                          v-mask="'##.###.###/####-##'"
                          required
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :lg="6" :sm="6" :xs="24">
                      <el-form-item
                        prop="business_date"
                        label="Data de abertura da empresa"
                        :error="error.business_date"
                      >
                        <el-date-picker
                          style="width: 100%"
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          v-model="ruleForm.business_date"
                          type="date"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :lg="12" :sm="12" :xs="24">
                      <el-form-item
                        prop="business_name"
                        label="Razão Social da empresa"
                        :error="error.business_name"
                      >
                        <el-input
                          size="business_name"
                          v-model="ruleForm.business_name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :lg="24" :md="24" :xs="24">
                      <el-form-item
                        prop="type_business_id"
                        label="Tipo de negócio"
                        :rules="[
                          {
                            required: true,
                            message: 'Requerido',
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <SelectSearchTypeBusiness
                          :model="ruleForm.type_business_id"
                          :isEdit="isEdit"
                          @handleValue="
                            (x) => {
                              ruleForm.type_business_id = x;
                            }
                          "
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item
                    prop="business_description"
                    label="Descrição/Observações da empresa"
                    :error="error.business_description"
                  >
                    <el-input
                      type="textarea"
                      :rows="2"
                      v-model="ruleForm.business_description"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane :disabled="!isEdit" label="Endereço" name="address">
            <el-row :gutter="20">
              <el-col :lg="12" :md="12">
                <el-form-item prop="postal_code" label="CEP" :error="error.postal_code">
                  <el-input masked="true" size="large" v-mask="['#####-###']" v-model="ruleForm.postal_code" required></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="12" :xs="24">
                <el-form-item prop="type_address" label="Tipo de Endereço" :error="error.type_address">
                  <el-select v-model="ruleForm.type_address" clearable style="width: 100%">
                    <el-option label="Empresa" value="business" />
                    <el-option label="Pessoal" value="personal" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="18" :md="18">
                <el-form-item prop="street" label="Endereço" :error="error.street">
                  <el-input size="large" v-model="ruleForm.street" required>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :md="6">
                <el-form-item prop="number" label="Nº" :error="error.number">
                  <el-input size="large" v-model="ruleForm.number" required>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="complement" label="Complemento" :error="error.complement">
              <el-input size="large" v-model="ruleForm.complement" required>
              </el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :lg="8" :md="8">
                <el-form-item prop="neighborhood" label="Bairro" :error="error.neighborhood">
                  <el-input size="large" v-model="ruleForm.neighborhood" type="text" required/>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8">
                <el-form-item prop="city_id" label="Cidade" :error="error.city_id">
                  <el-select
                    size="large"
                    v-model="ruleForm.city_id"
                    style="width: 100%;"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Pesquise a Cidade"
                    :remote-method="serchCity"
                    :loading="loadingCity">
                    <el-option v-for="(item, index) in cityOptions" :key="index" :label="item.title" :value="item.id">
                      <span style="float: left">{{ item.title }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">DDD {{ item.iso_ddd }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8">
                <el-form-item prop="state_id" label="Estado" :error="error.state_id">
                  <el-select
                    size="large"
                    v-model="ruleForm.state_id"
                    style="width: 100%;"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Pesquise o Estado"
                    :remote-method="serchState"
                    :loading="loadingCity">
                    <el-option v-for="(item, index) in StateOptions" :key="index" :label="item.title" :value="item.id">
                      <span style="float: left">{{ item.title }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.letter }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import HeaderPage from "@/app/components/HeaderPage";
import SelectSearchPhoneOperator from "@/app/components/PhoneOperator/SelectSearchPhoneOperator";
import SelectSearchTypeBusiness from "@/app/components/TypeBusiness/SelectSearchTypeBusiness";
import {getCity, getState} from "@/app/domains/Config/services";
import {
  deleteGerenteMarketplaces,
  getGerenteMarketplaces,
  postGerenteMarketplaces,
  putGerenteMarketplaces,
} from "@/app/domains/Records/services";
import {
  clearRuleForm,
  getErrorFilds,
  makeErrorFilds,
  validateCNPJ,
  validateCPF,
  validateEmail
} from "@/app/plugins/utils";
import SelectSearchMCC from "@/app/components/MCC/SelectSearchMCC";
import { mapGetters } from "vuex";

export default {
  name: "EditAddMarketplace",
  components: {
    HeaderPage,
    SelectSearchPhoneOperator,
    SelectSearchMCC,
    SelectSearchTypeBusiness,
  },
  data() {
    return {
      listDataCustoOpera: {},
      activeNameTabs: "1",
      loadingPage: false,
      loadingCity: false,
      cityOptions: [],
      StateOptions: [],
      error: {},
      ruleForm: {
        mcc_id: "",
        name: "",
        birthday: "",
        gender: "",
        type_person: "",
        cpf: "",
        rg: "",
        name_store: "",
        title_login: "",
        description_login: "",
        url_button_login: "",
        color_primary: "",
        color_secondary: "",
        type_contact: "",
        phone_operator_id: "",
        phone: "",
        email: "",
        business_cnpj: "",
        business_name: "",
        business_date: "",
        business_description: "",
        type_business_id: "",
        status: "",
      },
      rules: {
        name: [{ required: true, message: "Requerido", trigger: "blur" }],
        birthday: [{ required: true, message: "Requerido", trigger: "blur" }],
        cpf: [{ required: true, message: "Requerido", trigger: "blur" },
          { validator: this.cpfVerify, trigger: "blur"}],
        email: [{ required: true, message: "Requerido", trigger: "blur" },
          { validator: this.emailVerify, trigger: "blur"}],
        gender: [{ required: true, message: "Requerido", trigger: "blur" }],
        mcc_id: [{ required: true, message: "Requerido", trigger: "blur" }],
        name_store: [{ required: true, message: "Requerido", trigger: "blur" }],
        phone_operator_id: [
          { required: true, message: "Requerido", trigger: "blur" },
        ],
        type_contact: [
          { required: true, message: "Requerido", trigger: "blur" },
        ],
        type_person: [
          { required: true, message: "Requerido", trigger: "blur" },
        ],
        business_cnpj: [
          { required: true, message: "Requerido", trigger: "blur" },
          { validator: this.cnpjVerify, trigger: "blur"}
        ],
        business_date: [
          { required: true, message: "Requerido", trigger: "blur" },
        ],
        business_name: [
          { required: true, message: "Requerido", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("Auth", ["getToken"]),
    isEdit: function () {
      return !!this.ruleForm.id;
    },
  },
  methods: {
    async serchCity(query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getCity('?name=' + query)
          this.cityOptions = response.data.data
          this.$set(this.ruleForm, 'country_code', 55)
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    async serchState(query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getState('?name=' + query)
          this.StateOptions = response.data.data
        } catch (e) {
          
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    cpfVerify (rule, value, callback) {
      if (validateCPF(this.ruleForm.cpf)) {
        callback()
      } else {
        callback(new Error('CPF Invalido'))
      }
    },
    cnpjVerify (rule, value, callback) {
      if (validateCNPJ(this.ruleForm.business_cnpj)) {
        callback()
      } else {
        callback(new Error('CNPJ Invalido'))
      }
    },
    emailVerify (rule, value, callback) {
      if (validateEmail(this.ruleForm.email)) {
        callback()
      } else {
        callback(new Error('Email Invalido'))
      }
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(async (valid, i) => {
        if (valid) {
          this.error = [];
          try {
            this.loadingPage = true;
            if (this.$route.params.id) {
              this.$set(this.ruleForm, "country_code", 55);
              await putGerenteMarketplaces(clearRuleForm(this.ruleForm));
              this.$message({
                showClose: true,
                message: "Editado com Sucesso",
                type: "success",
              });
              await this.$router.push({
                name: "records.gerentemarketplaces.index",
              });
            } else {
              await postGerenteMarketplaces(this.ruleForm);
              this.$message({
                showClose: true,
                message: "Adicionado com sucesso",
                type: "success",
              });
              await this.$router.push({
                name: "records.gerentemarketplaces.index",
              });
            }
          } catch (e) {
            this.error = getErrorFilds(e);
            this.activeNameTabs = "address";
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: "error",
            });
          } finally {
            this.loadingPage = false;
          }
        } else {
          
          for (let [key, value] of Object.entries(i)) {
            this.$notify.error({
              message: "Campo: " + key + " é Requerido",
            });
          }
        }
      });
    },
    async handleAction(act) {
      if (act === "DELETE") {
        this.loadingPage = true;
        this.$confirm("Deseja realmente deletar este Gerente de Marketplace?", "Atenção", {
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
          center: true,
          type: "warning",
        })
          .then(async () => {
            try {
              await deleteGerenteMarketplaces(this.ruleForm.id);
              await this.$router.push({ name: "records.gerentemarketplaces.index" });
              this.$message({
                showClose: true,
                message: "Gerente de Marketplace foi excluido.",
                type: "success",
              });
            } catch (e) {
              this.$message({
                showClose: true,
                message: e.data,
                type: "error",
              });
            } finally {
              this.loadingPage = false;
            }
          })
          .catch(() => {
            this.loadingPage = false;
          });
      }
    },
  },
  async mounted() {
    try {
      if (this.$route.params.id) {
        this.loadingPage = true;
        let response = await getGerenteMarketplaces(
          `/${this.$route.params.id}`
        );
        this.ruleForm = response.data.person;
        this.$set(this.ruleForm, 'id', response.data.id)
        this.$set(this.ruleForm, 'title_login', response.data.title_login)
        this.$set(this.ruleForm, 'url_button_login', response.data.url_button_login)
        this.$set(this.ruleForm, 'description_login', response.data.description_login)
        this.$set(this.ruleForm, 'color_primary', response.data.color_primary)
        this.$set(this.ruleForm, 'color_secondary', response.data.color_secondary)
        this.$set(this.ruleForm, 'type_contact', response.data.person.contact.type_contact)
        this.$set(this.ruleForm, 'phone_operator_id', response.data.person.contact.phone_operator_id)
        this.$set(this.ruleForm, 'phone', response.data.person.contact.phone)
        this.$set(this.ruleForm, 'email', response.data.person.contact.email)
        this.$set(this.ruleForm, 'status', response.data.person.status)

        if (response.data.person.type_person === "business") {
          this.$set(this.ruleForm, 'business_cnpj', response.data.person.business[0].business_cnpj)
          this.$set(this.ruleForm, 'business_date', response.data.person.business[0].business_date)
          this.$set(this.ruleForm, 'business_description', response.data.person.business[0].business_description)
          this.$set(this.ruleForm, 'business_name', response.data.person.business[0].business_name)
          this.$set(this.ruleForm, 'type_business_id', response.data.person.business[0].type_business_id)
        }

        if (response.data.person.address) {
          this.$set(this.ruleForm, 'postal_code', response.data.person.address.postal_code)
          this.$set(this.ruleForm, 'street', response.data.person.address.street)
          this.$set(this.ruleForm, 'number', response.data.person.address.number)
          this.$set(this.ruleForm, 'complement', response.data.person.address.complement)
          this.$set(this.ruleForm, 'neighborhood', response.data.person.address.neighborhood)
          if (response.data.person.address.city !== null) {
            this.cityOptions = [response.data.person.address.city]
            this.$set(this.ruleForm, 'city_id', response.data.person.address.city?.id)
            this.StateOptions = [response.data.person.address.state]
            this.$set(this.ruleForm, 'state_id', response.data.person.address.state?.id)
          }

          this.$set(this.ruleForm, 'type_address', response.data.person.address.type_address)
        }
      }
    } catch (e) {
      this.error = getErrorFilds(e);
      this.$message({
        showClose: true,
        message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
        type: "error",
      });
    } finally {
      this.loadingPage = false;
    }
  },
};
</script>

<style scoped></style>
